import React, {Ref, useRef} from 'react';
import Box from "../../Common/Box";
import utils from "../../lib/utils";
import {Message} from "../../lib/stores/MessageStore";
import {action} from "mobx";
import uiStore from "../../lib/stores/uiStore";
import {lighten, useTheme} from "@mui/material/styles";

const styles = {
    root: {
        width: "100%",
        lineHeight: 1.375,
        wordWrap: "break-word",
        overflow: "hidden"
    },
    content: {
        boxShadow: "0 2px 2px 0 rgba(0, 0, 0, 0.24), 0 3px 1px -2px rgba(0, 0, 0, 0.24), 0 1px 5px 0 rgba(0, 0, 0, 0.2)",
        display: "flex",
        wordBreak: "break-word"
    },
    text: {
        padding: "12px 12px"
    },
};

interface UserEventMessageProps {
    message: Message
    text: string
    forwardedRef: Ref<HTMLDivElement>
}

const UserEventMessage: React.FC<UserEventMessageProps> = ({message, text, forwardedRef}) => {

    const theme = useTheme();
    const avatarRef = useRef();
    const usernameRef = useRef();
    const {embeds: [{user}]} = message;

    return <Box
            padding={"4px 15px"}
            bgcolor={"list.background"}
            forwardedRef={forwardedRef}
            sx={styles.root}
    >
        <Box
                sx={styles.content}
                display={"flex"}
                flex={1}
                alignItems={"center"}
                color={"text.secondary"}
                borderRadius={"4px"}
                bgcolor={"background.default"}
        >
            <Box sx={styles.text}>
                <Box
                        ref={usernameRef}
                        onClick={action(function () {
                            uiStore.userInfoView = {
                                userInfoPlacement: "right-start",
                                selectedUser: user,
                                userAnchorEl: usernameRef,
                            }

                            uiStore.userInfoVisible = true;
                        })}

                        sx={{
                            cursor: "pointer",
                            color: lighten(theme.palette.text.primary, 0),
                        }}
                        component={"span"}
                >
                    {user.username}
                </Box>
                {text}
            </Box>
            <img
                    ref={avatarRef}
                    onClick={action(function () {
                        uiStore.userInfoView = {
                            userInfoPlacement: "right-start",
                            selectedUser: user,
                            userAnchorEl: avatarRef,
                        }

                        uiStore.userInfoVisible = true;
                    })}
                    crossOrigin={"anonymous"}
                    style={{
                        cursor: "pointer",
                        width: "30px",
                        height: "30px",
                        borderRadius: "15px",
                        marginLeft: "10px",
                        marginRight: "10px"
                    }}
                    src={utils.createAvatarUrl(user['avatar'], 30)}
                    alt={'avatar'}/>
        </Box>

    </Box>
};

export default UserEventMessage;
